import { PreviewPanel } from '../listing/listing-preview.js';
import { CartoPanel } from '../listing/listing-carto.js';
import {
  manageButton,
  isInSelection,
  toggleSelection,
} from '../selection/utils.js';
import { checkImageInError, clampLines } from '../utils/utils.js';
import { displayModal, hideModal, initModal } from '../modal/modal.js';

let globalClickListener;
let previewBtnListener;
let cartoBtnListener;

const DEFAULT_OPTIONS = {
  initialDisplayMode: 'liste',
  onDisplayModeChanged: () => {},
};
export const init = (
  containerSelector = '.search-results',
  options = DEFAULT_OPTIONS,
) => {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  // Gestion de la case à cocher "Tout sélectionner"
  const selectAllCheckbox = document.querySelector(
    '[data-action="results-list:select-all"] input[type="checkbox"]',
  );
  if (selectAllCheckbox) {
    selectAllCheckbox.addEventListener('change', () => {
      const inputs = document.querySelectorAll('input[name="listing:select"]');
      inputs.forEach((input) => {
        input.checked = selectAllCheckbox.checked;
        input
          .closest('.listing-element')
          .toggleAttribute('data-selected', selectAllCheckbox.checked);
      });
      checkSelectionAddAllButtonStatus();
      checkMassActions();
    });
    document
      .querySelectorAll('.listing input[name="listing:select"]')
      .forEach((input) => {
        input.addEventListener('change', () => {
          input
            .closest('.listing-element')
            .toggleAttribute('data-selected', input.checked);

          selectAllCheckbox.checked = [
            ...document.querySelectorAll(
              '.listing input[name="listing:select"]',
            ),
          ].every((input) => input.checked);
        });
      });
  }

  document
    .querySelectorAll('.listing-element [data-action="selection:add"]')
    .forEach((button) => {
      manageButton(button);
    });

  const selectionAddAllButton = document.querySelector(
    '.search-results-list-actions [data-action="selection:add-all"]',
  );
  if (selectionAddAllButton) {
    selectionAddAllButton.addEventListener('click', () => {
      const newStatus = !selectionAddAllButton.matches('.en-selection');
      document
        .querySelectorAll('input[name="listing:select"]:checked')
        .forEach((input) => {
          const id = input.getAttribute('data-id');
          const type = input.getAttribute('data-type');
          toggleSelection(type, id, newStatus);
        });

      checkSelectionAddAllButtonStatus();
      checkMassActions();
    });

    document.addEventListener('selection:changed', () =>
      checkSelectionAddAllButtonStatus(),
    );
  }

  document
    .querySelectorAll('.listing-element-checkbox input[name="listing:select"]')
    .forEach((input) => {
      input.addEventListener('change', () => {
        checkSelectionAddAllButtonStatus();
        checkMassActions();
      });
    });

  function checkSelectionAddAllButtonStatus() {
    const elementCheckboxes = Array.from(
      document.querySelectorAll(
        '.listing-element-checkbox input[name="listing:select"]:checked',
      ),
    );
    const allSelected =
      elementCheckboxes.length > 0 &&
      elementCheckboxes.every((button) => {
        const type = button.getAttribute('data-type');
        const id = button.getAttribute('data-id');
        return isInSelection(type, id);
      });
    selectionAddAllButton.classList.toggle('en-selection', allSelected);
  }

  document
    .querySelector('[data-action="selection:print"]')
    ?.addEventListener('click', () => window.print());

  const listingActions = document.querySelectorAll(`
    [data-action="selection:add-all"],
    [data-action="selection:contact"],
    [data-action="selection:pdfZip"],
    [data-action="results-list:pdfDropdown"]
  `);
  const contactAction = document.querySelector(
    '[data-action="selection:contact"]',
  );
  const initialHref = contactAction?.getAttribute('href');

  const pdfAction = document.querySelector('[data-action="selection:pdf"]');
  const pdfZipAction = document.querySelector(
    '[data-action="selection:pdfZip"]',
  );
  function checkMassActions() {
    const elementCheckboxes = Array.from(
      document.querySelectorAll(
        '.listing-element-checkbox input[name="listing:select"]:checked',
      ),
    );

    listingActions.forEach((action) =>
      action.toggleAttribute('disabled', !elementCheckboxes.length),
    );

    if (contactAction) {
      const body =
        'Demande à propos de :\n' +
        elementCheckboxes
          .map((checkbox) => {
            const type = checkbox.getAttribute('data-type');
            const reference = checkbox.getAttribute('data-reference');
            return `${
              type === 'dossier' ? 'Dossier' : 'Illustration'
            } ${reference}`;
          })
          .join(',\n');
      contactAction.setAttribute(
        'href',
        initialHref + encodeURIComponent(body),
      );
    }

    [pdfAction, pdfZipAction]
      .filter((actionButton) => !!actionButton)
      .forEach((actionButton) => {
        const form = actionButton.closest('form');
        form
          .querySelectorAll('input[type="hidden"]')
          .forEach((input) => input.remove());

        // On sépare les biblios car elles ont un PDF spécifique
        const biblios = [];
        const rest = [];

        elementCheckboxes.forEach((checkbox) => {
          const type = checkbox.getAttribute('data-type');

          if (type === 'biblio') {
            biblios.push(checkbox);
          } else {
            rest.push(checkbox);
          }
        });

        const pdfDropdown = document.querySelector(
          '[data-action="results-list:pdfDropdown"]',
        );
        const pdfDropdownWrapper = document.querySelector(
          '[data-action="results-list:pdfDropdownWrapper"]',
        );

        if (biblios.length > 0 && rest.length > 0) {
          pdfDropdown.removeAttribute('open');
          pdfDropdown.setAttribute('disabled', 'true');
          pdfDropdownWrapper.setAttribute(
            'title',
            "Vous ne pouvez pas imprimer de PDFs si vous avez sélectionné des Notices Bibliographiques en même temps que des Dossiers et Notices d'Illustrations.",
          );
        } else {
          if (biblios.length > 0 || rest.length > 0) {
            pdfDropdown.removeAttribute('disabled');
            pdfDropdownWrapper.removeAttribute('title');
          }

          const action = form.getAttribute('data-action');
          const biblioAction = form.getAttribute('data-biblio-action');

          if (rest.length > 0 && action) {
            form.setAttribute('action', action);
          }

          if (biblios.length > 0) {
            if (biblioAction) {
              form.setAttribute('action', biblioAction);
            }
            pdfZipAction.setAttribute('disabled', 'true');
          }

          elementCheckboxes.forEach((checkbox) => {
            const type = checkbox.getAttribute('data-type');
            const id = checkbox.getAttribute('data-id');

            const input = document.createElement('input');

            input.setAttribute('type', 'hidden');
            input.setAttribute('name', `${type}Id`);
            input.setAttribute('value', id);
            form.appendChild(input);
          });
        }

        const urlInput = document.createElement('input');
        urlInput.setAttribute('type', 'hidden');
        urlInput.setAttribute('name', 'url');
        urlInput.setAttribute('value', location.origin);
        form.appendChild(urlInput);
      });
  }
  let currentPanel;

  const previewContainer = document.querySelector(
    '.search-results-preview-content',
  );
  const previewButton = document.querySelector(
    '.search-results-preview-action[data-action="search:open-preview"]',
  );
  previewBtnListener = () => openPreview();
  previewButton?.addEventListener('click', previewBtnListener);

  const cartoButton = document.querySelector(
    '.search-results-preview-action[data-action="search:open-carto"]',
  );
  cartoBtnListener = () => openCarto();
  cartoButton?.addEventListener('click', cartoBtnListener);

  const firstElement = document.querySelector('.listing-element');

  document
    .querySelectorAll('.listing-element-maintitle')
    .forEach((titleElement) => clampLines(titleElement, 1));

  document
    .querySelectorAll('.listing-element-subtitle')
    .forEach((titleElement) => clampLines(titleElement, 1));

  document
    .querySelectorAll('.listing-element .listing-element-preview')
    .forEach((element) => {
      const listingElement = element.closest('.listing-element');
      element.addEventListener('click', () => {
        if (currentPanel == null) {
          openPreview(listingElement);
        } else {
          currentPanel.setElement(listingElement);
        }
      });
    });

  globalClickListener = ({ target }) => {
    const button = target.closest('[data-action]');
    if (button) {
      switch (button.getAttribute('data-action')) {
        case 'search-result-details:previous':
          currentPanel.previousElement();
          break;
        case 'search-result-details:next':
          currentPanel.nextElement();
          break;
        case 'search-result-details:open-preview-tab':
          openPreview(getFirstSelectedElement());
          break;
        case 'search-result-details:open-carto-tab':
          openCarto(getFirstSelectedElement());
          break;
        case 'search-result-details:close':
          closePanel();
          break;
        default:
          return; // noop
      }
    }
  };

  document
    .querySelector('.search-results-preview')
    ?.addEventListener('click', globalClickListener);

  let initialDisplayMode;
  const savedDisplayMode = localStorage.getItem('listing:display-mode');
  if (!options?.initialDisplayMode || options?.initialDisplayMode === 'liste') {
    initialDisplayMode = savedDisplayMode;
  } else {
    initialDisplayMode =
      options?.initialDisplayMode || savedDisplayMode || 'liste';
  }

  const listingContainer = document.querySelector('.listing');
  const displayModeButtons = document.querySelectorAll(
    '.search-results-list-actions [data-action="listing:display-mode"]',
  );
  displayModeButtons.forEach((displayModeButton) => {
    const displayMode = displayModeButton.getAttribute('data-listing-mode');

    if (displayMode === initialDisplayMode) {
      listingContainer.setAttribute('data-listing-mode', displayMode);
    } else {
      displayModeButton.removeAttribute('disabled');
    }

    displayModeButton.addEventListener('click', () => {
      displayModeButtons.forEach((button) =>
        button.toggleAttribute('disabled', displayModeButton === button),
      );

      listingContainer.setAttribute('data-listing-mode', displayMode);

      if (displayMode === 'liste' || displayMode === 'mosaique') {
        localStorage.setItem('listing:display-mode', displayMode);
      }

      options?.onDisplayModeChanged?.(displayMode);
    });
  });

  options?.onDisplayModeChanged?.(initialDisplayMode);

  container
    .querySelectorAll('.listing-element-vignette img')
    .forEach((vignette) =>
      checkImageInError(vignette, '.listing-element-vignette'),
    );

  function closePanel() {
    previewContainer.innerHTML = '';
    container.setAttribute('data-preview', 'closed');

    cleanCurrentPreviewedElement();
    currentPanel = null;
  }

  function openPreview(selectedElement = firstElement) {
    currentPanel = new PreviewPanel(previewContainer, handleElementSelection);
    container.setAttribute('data-preview', 'opened');
    container.setAttribute('data-preview-type', 'preview');

    currentPanel.setElement(selectedElement);
  }

  async function openCarto(selectedElement = firstElement) {
    currentPanel = new CartoPanel(
      previewContainer,
      '#carte',
      handleElementSelection,
    );
    container.setAttribute('data-preview', 'opened');
    container.setAttribute('data-preview-type', 'carto');

    currentPanel.setElement(selectedElement);
  }

  function handleElementSelection(element) {
    cleanCurrentPreviewedElement();
    setElementAsCurrent(element);
    scrollToElement(element);
  }

  function getFirstSelectedElement() {
    return document.querySelector('.listing-element[data-preview-current]');
  }

  function cleanCurrentPreviewedElement() {
    document
      .querySelectorAll('.listing-element[data-preview-current]')
      .forEach((element) => element.removeAttribute('data-preview-current'));
  }

  function setElementAsCurrent(element) {
    element.setAttribute('data-preview-current', '');
  }

  function scrollToElement(element) {
    const headerSize = firstElement.offsetTop;
    window.scroll({
      top: element.offsetTop - headerSize,
      behavior: 'smooth',
    });
  }

  function cleanState() {
    closePanel();
    cleanCurrentPreviewedElement();

    if (globalClickListener) {
      document
        .querySelector('.search-results-preview')
        .removeEventListener('click', globalClickListener);
    }

    if (previewBtnListener) {
      const previewButton = document.querySelector(
        '.search-results-preview-action[data-action="search:open-preview"]',
      );
      previewButton.removeEventListener('click', previewBtnListener);
    }
    if (cartoBtnListener) {
      const cartoButton = document.querySelector(
        '.search-results-preview-action[data-action="search:open-carto"]',
      );
      cartoButton.removeEventListener('click', cartoBtnListener);
    }
  }

  const downloadPdfButtons = document.querySelectorAll(
    '[data-action="selection:downloadPdf"]',
  );
  downloadPdfButtons.forEach((button) => {
    const id = button.dataset.id;
    const modal = document.querySelector(`[id="modalTelechargerPdf_${id}"]`);
    if (!modal) {
      return;
    }

    initModal(modal, button);

    const downloadPdfForm = modal.querySelector('[data-action="download:pdf"]');
    if (downloadPdfForm) {
      downloadPdfForm.addEventListener('submit', () => {
        hideModal(modal);
      });
    }
  });

  const downloadZippedPdfButton = document.querySelector(
    '[data-action="selection:pdfZip"]',
  );
  const modal = document.querySelector('#modalTelechargerPdf_zip');
  if (downloadZippedPdfButton && modal) {
    initModal(modal);

    const downloadPdfForm = modal.querySelector('[data-action="download:pdf"]');
    if (downloadPdfForm) {
      downloadPdfForm.addEventListener('submit', () => {
        hideModal(modal);
      });

      const form = downloadZippedPdfButton.closest('form');
      form.addEventListener('submit', (event) => {
        const dossierInputs = form.querySelectorAll(
          'input[type="hidden"][name="dossierId"]',
        );
        if (dossierInputs.length) {
          displayModal(modal);
          event.preventDefault();

          // on recopie les inputs du form principal vers celui dans la modale
          downloadPdfForm
            .querySelectorAll(
              'input[type="hidden"][name="dossierId"], input[type="hidden"][name="illustrationId"]',
            )
            .forEach((input) => input.remove());
          form
            .querySelectorAll(
              'input[type="hidden"][name="dossierId"], input[type="hidden"][name="illustrationId"]',
            )
            .forEach((input) => {
              const duplicatedInput = document.createElement('input');
              duplicatedInput.setAttribute('type', 'hidden');
              duplicatedInput.setAttribute('name', input.getAttribute('name'));
              duplicatedInput.setAttribute('value', input.value);
              downloadPdfForm.appendChild(duplicatedInput);
            });
        }
      });
    }
  }

  return { cleanState };
};
